module.exports = __webpack_public_path__ + "static/media/icon-circles.1a9c9976.png";